module.exports = __webpack_public_path__ + "static/img/duom04.1847c04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom04.png
// module id = 980
// module chunks = 0